var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M15.665 22.62c.824 0 1.481-.237 1.972-.71.49-.472.735-1.106.735-1.9V3.96c0-.787-.245-1.42-.735-1.896s-1.148-.714-1.972-.714H8.318c-.824 0-1.483.238-1.977.714-.494.477-.741 1.109-.741 1.896v16.05c0 .794.247 1.428.741 1.9.494.473 1.153.71 1.977.71h7.347zm-.182-1.483H8.5c-.465 0-.818-.116-1.058-.349-.24-.233-.36-.571-.36-1.015V4.197c0-.444.12-.783.36-1.015.24-.233.593-.35 1.058-.35h.398v.452c0 .2.06.363.182.488a.642.642 0 00.484.188h4.855c.2 0 .364-.062.49-.188a.664.664 0 00.187-.488v-.451h.387c.458 0 .81.116 1.053.349.243.232.365.57.365 1.015v15.576c0 .444-.122.782-.365 1.015-.244.233-.595.35-1.053.35zm-.838-.741c.129 0 .236-.04.322-.118a.417.417 0 00.13-.323.42.42 0 00-.13-.316.444.444 0 00-.322-.124H9.338a.428.428 0 00-.317.124.429.429 0 00-.123.316c0 .137.041.244.123.323a.44.44 0 00.317.118h5.307z"
  }))));
}

export default SvgMobile;